import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { StorageOfferDetailsResponse } from 'src/apis/storage/types';
import type { PublicStorageOffersRequest } from 'src/apis/storage/use-public-storage-offers';
import type { Successful } from 'src/hooks/use-axios';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageOffers?: PublicStorageOffersRequest;
  offerId: string;
};

type ExecuteOptions = {
  storageOffers: Successful<PublicStorageOffersRequest>;
  offerId: string;
};

export function useStorageOfferDetails({
  storageOffers,
  offerId,
}: HookOptions) {
  const storageOffer = useAxios(
    (axios, baseConfig, { storageOffers, offerId }: ExecuteOptions) => {
      const url = urlTemplate
        .parse(storageOffers.response.data._links.instance.href)
        .expand({ offerId });

      return axios.request<StorageOfferDetailsResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageOffers?.response) return;

    storageOffer.execute({
      storageOffers,
      offerId,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageOffers?.response, offerId]);

  if (!storageOffers?.response) return;

  return storageOffer;
}

export type StorageOfferDetailsRequest = ReturnType<
  typeof useStorageOfferDetails
>;
